<template>
	<div id="app">
		<div class="row">
			<card-container ref="card_1" :type="constant.CARD_INSTAGRAM" color="orange" :message="cardData.message[1]" :image="cardData.image[1]" />
			<card-container ref="card_2" :type="constant.CARD_INSTAGRAM" color="purple" :message="cardData.message[2]" :image="cardData.image[2]" />
			<card-container ref="card_3" :type="constant.CARD_INSTAGRAM" color="green" :message="cardData.message[3]" :image="cardData.image[3]" />
			<card-container ref="card_4" :type="constant.CARD_INSTAGRAM" color="red" :message="cardData.message[4]" :image="cardData.image[4]" />
		</div>
		<div class="row row--shift-big">
			<card-container ref="card_5" :type="constant.CARD_INSTAGRAM" color="orange" :message="cardData.message[5]" :image="cardData.image[5]" />
			<card-container ref="card_6" :type="constant.CARD_INSTAGRAM" color="red" :message="cardData.message[6]" :image="cardData.image[6]" />
			<card-container ref="card_7" :type="constant.CARD_INSTAGRAM" color="green" :message="cardData.message[7]" :image="cardData.image[7]" />
			<card-container ref="card_8" :type="constant.CARD_INSTAGRAM" color="orange" :message="cardData.message[8]" :image="cardData.image[8]" />
			<card-container ref="card_9" :type="constant.CARD_INSTAGRAM" color="purple" :message="cardData.message[9]" :image="cardData.image[9]" />
		</div>
		<div class="row">
			<card-container ref="card_10" :type="constant.CARD_INSTAGRAM" color="blue" :message="cardData.message[10]" :image="cardData.image[10]" />
			<card-container ref="card_11" :type="constant.CARD_INSTAGRAM" color="red" :message="cardData.message[11]" :image="cardData.image[11]" />
			<card-container ref="card_12" :type="constant.CARD_INSTAGRAM" color="purple" :message="cardData.message[12]" :image="cardData.image[12]" />
			<card-container ref="card_13" :type="constant.CARD_INSTAGRAM" color="green" :message="cardData.message[13]" :image="cardData.image[13]" />
			<card-container ref="card_14" :type="constant.CARD_INSTAGRAM" color="blue" :message="cardData.message[14]" :image="cardData.image[14]" />
		</div>
		<div :class="{'lightbox-bg': true, 'active': lightbox}" ref="lightbox" @click.self="toggleItem(null)"></div>
		<!--app-counter :donations="donationsCount" /-->
	</div>
</template>

<script>
import Pusher from 'pusher-js';
import axios from 'axios';
import * as constant from './constants';
import CardContainer from './components/CardContainer';
import CardGift from './components/CardGift';
import CardInstagram from './components/CardInstagram';
import AppCounter from './components/AppCounter';

export default {
	name: 'App',
	components: { CardContainer, CardGift, CardInstagram, AppCounter },
	data () {
		return require('./App.json');
	},
	computed: {
		constant: () => constant,
	},
	async mounted () {
		const _this = this;

		Pusher.logToConsole = true;
		const pusher = new Pusher(constant.PUSHER_API, {
			cluster: 'ap1',
			encrypted: true,
		});

		const sleep = ms => {
			return new Promise((resolve, reject) => setTimeout(resolve, ms));
		};

		let runningLock = false;
		axios.get(process.env.NODE_ENV !== 'production' ? '/static/cards.json' : '/assets/cards.json').then(async (response) => {
			const { data } = response;
			document.body.classList.remove('loading');
			// Is there a running process? If yes, terminate.
			if (runningLock) {
				return;
			}

			// Set the lock and iterate through items.
			runningLock = true;

			const cards = [...data.cards];

			// eslint-disable-next-line
			const { donations, interval, openTiming, closeTiming, waitTiming, onscreenTiming } = data.settings;

			_this.donationsCount = donations;
			document.body.style.setProperty('--closeTiming', `${closeTiming / 1000}s`);
			document.body.style.setProperty('--openTiming', `${openTiming / 1000}s`);

			const donationsId = [];
			const mediaId = [];

			const diffSize = 14 - cards.length;
			const diffPool = [...data.cards].sort(() => Math.floor(Math.random() * cards.length));
			if (diffSize > 0) {
				for (let i = 0; i < diffSize; i++) {
					const newCard = {...diffPool.pop()};
					newCard.position = data.cards.length + i + 1;
					cards.push(newCard);
				}
			}

			// Change the grid content.
			for (let card of cards) {
				if (card.type === 'donation') {
					// eslint-disable-next-line
					const {id, from, to, message, position, present} = card;
					donationsId.push(id);
					_this.cardData.from[position] = from;
					_this.cardData.to[position] = to;
					_this.cardData.message[position] = message;
					_this.cardData.present[position] = present;
				} else {
					// It's Instagram
					// eslint-disable-next-line
					const {id, message, image, position} = card;
					mediaId.push(id);
					_this.cardData.message[position] = message;
					_this.cardData.image[position] = image;
				}
			}

			// Iterate through all cards.
			for (let card of cards) {
				await sleep(waitTiming);
				_this.toggleItem(_this.$refs[`card_${card.position}`]);
				await sleep(onscreenTiming);
				_this.toggleItem(null);
			}

			// Disable the lock
			runningLock = false;

			// Mark data as displayed
			// axios.get(`${constant.API_URL}/data/displayed`, {
			// 	params: {
			// 		donations: donationsId.join(','),
			// 		media: mediaId.join(','),
			// 	},
			// });
		});

		// Send the first data in!
		// channel.bind('pusher:subscription_succeeded', () => {
		// 	axios.get(`${constant.API_URL}/data/send`);
		// });
	},
	methods: {
		toggleItem (target) {
			const self = this;
			let element = target;

			if (target && typeof target.$el !== 'undefined') {
				element = target.$el;
			}

			if (element) {
				target.activate();
				this.activeItem = element;
				this.calculateCenter(element);
				this.activeItem.classList.add('active');
			}

			if (this.lightbox) {
				this.$refs.lightbox.classList.add('close');
				this.activeItem.classList.add('close');
				setTimeout(() => {
					self.lightbox = !self.lightbox;
					self.activeItem.classList.remove('active');
					self.activeItem.classList.remove('close');
					self.$refs.lightbox.classList.remove('close');
				}, this.lightboxcloseTiming);
			} else {
				this.lightbox = true;
			}
		},
		calculateCenter (target) {
			const targetX = target.clientWidth / 2 + target.offsetLeft;
			const targetY = target.clientHeight / 2 + target.offsetTop;
			const moveX = window.innerWidth / 2 - targetX;
			const moveY = window.innerHeight / 2 - targetY;

			document.body.style.setProperty('--moveX', `${moveX}px`);
			document.body.style.setProperty('--moveY', `${moveY}px`);
		},
	},
};
</script>


<style lang=less>
	@import url('../node_modules/normalize.css/normalize.css');
	@import (reference) 'assets/less/default.less';

	@font-face {
		font-family: 'futura-pt';
		src: url('assets/fonts/hinted-subset-FuturaBT-Medium.eot');
		src: local('Futura Medium BT'), local('FuturaBT-Medium'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.eot?#iefix') format('embedded-opentype'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.woff') format('woff'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.ttf') format('truetype');
		font-weight: 500;
		font-style: normal;
	}

	@font-face {
		font-family: 'futura-pt-bold';
		src: url('assets/fonts/hinted-subset-FuturaBT-Bold.eot');
		src: local('Futura Bold BT'), local('FuturaBT-Bold'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.eot?#iefix') format('embedded-opentype'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.woff') format('woff'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.ttf') format('truetype');
		font-weight: bold;
		font-style: normal;
	}

	:root {
		--moveX: 25vw;
		--moveY: 25vh;
		--openTiming: 3s;
		--closeTiming: 0.3s;
	}

	html { font-size: 16px; box-sizing: border-box;
		@media screen and (max-width: 1024px) { font-size: 12px; }
	}
	html, body { overflow: hidden; background-color: #ececec;
		background-image: url('./assets/images/bg-left.svg'), url('./assets/images/bg-right.svg');
		background-position: 0 0, 100% 0;
		background-repeat: no-repeat;
	}
	*, *:before, *:after { box-sizing: inherit; }
	body { .regular(); .font-antialiasing();
		&:before { pointer-events: none; transition: opacity 1s ease; opacity: 0; .top-left(0, 0, 1000); .pseudo(); .size(100vw, 100vh); background-color: #ececec; }
		&:after { pointer-events: none; transition: opacity 1s ease; opacity: 0; .top-left(calc(50% - 32px), calc(50% - 70px), 1001); display: block; content: "Loading..."; padding-top: 64px; .size(140px, 64px); background: transparent url('./assets/images/loading.svg') 0 0 no-repeat; color: @red; text-align: center; }
		&.loading {
			&:before { opacity: 1; }
			&:after { opacity: 1; }
		}
	}
	h1, h2, h3, h4 { .bold(); }

	.row { display: flex;
		&--shift { margin-left: -6vw; }
		&--shift-big { margin-left: -10vw; }
	}

	.lightbox-bg { transition: all 1s ease;
		@keyframes lightbox-close {
			0% { background-color: rgba(0, 0, 0, .6); }
			100% { background-color: rgba(0, 0, 0, 0); }
		}

		&.active { .top-left-f(0, 0, 15); .size(100vw, 100vh); background-color: rgba(0, 0, 0, .6); }
		&.active.close { animation: lightbox-close var(--closeTiming) ease-out forwards; }
	}

	.card {
		.fillAnimation(@color) {
			.gift-animation {
				path { stroke: @color; }
				path[fill^="rgb"] { fill: @color; }
				path[fill="rgb(255,255,255)"] { fill: white; }
			}
		}
		&--orange {
			.fillAnimation(@orange);
		}
		&--green {
			.fillAnimation(@green);
		}
		&--purple {
			.fillAnimation(@purple);
		}
		&--red {
			.fillAnimation(@red);
		}
		&--blue {
			.fillAnimation(@blue);
		}
	}

</style>



// WEBPACK FOOTER //
// src/App.vue